export enum SEARCH_TYPE {
  CITY = 'city',
  STREET = 'street',
  ADDRESS = 'address',
  PARCEL = 'parcel',
  CONTACT = 'contact',
}

export type Bounds = {
  northEast: {
    lat: number;
    lng: number;
  };
  southWest: {
    lat: number;
    lng: number;
  };
};

export type CitySearch = {
  address: string;
  lat: number;
  lng: number;
};

export type StreetSearch = {
  address: string;
  street: string;
  lat: number;
  lng: number;
  bounds: Bounds;
};
